import { QUALITY_BRUSH } from '../consts';

/**
 * Visible time window for the stream availability chart and overview brush (page-level state).
 */
export type VisibleTimeRange = {
  from: Date;
  to: Date;
};

/**
 * Clamps a brush interval to the full report domain and enforces a minimum duration (ms).
 */
export function clampVisibleTimeRange(
  rawFromMs: number,
  rawToMs: number,
  domainStartMs: number,
  domainEndMs: number,
  minMs: number = QUALITY_BRUSH.defaultMinSelectionMs,
): VisibleTimeRange {
  let x0 = Math.min(rawFromMs, rawToMs);
  let x1 = Math.max(rawFromMs, rawToMs);
  x0 = Math.max(domainStartMs, Math.min(x0, domainEndMs));
  x1 = Math.max(domainStartMs, Math.min(x1, domainEndMs));

  if (x1 - x0 < minMs) {
    x1 = Math.min(domainEndMs, x0 + minMs);
    if (x1 - x0 < minMs) {
      x0 = Math.max(domainStartMs, x1 - minMs);
    }
  }

  if (!(x1 > x0)) {
    return { from: new Date(domainStartMs), to: new Date(domainEndMs) };
  }

  return { from: new Date(x0), to: new Date(x1) };
}
